import * as React from 'react';
import { Container, Header } from 'semantic-ui-react';
import ReactSVG from 'react-svg';
import { IRootState } from 'store';
import * as App from 'application';
import './style.css';
import { NotificationMessageType } from 'store/modules/notifications';
import { connect } from 'react-redux';

interface ISubscriptionConfirmationProps {
  isShow: boolean;
}

const mapStateToProps = (state: IRootState) => ({
  isShow: (App.Operation.getNotificationsByType(state, [NotificationMessageType.newSubscription]).length > 0)
})

const Confirmation: React.SFC<ISubscriptionConfirmationProps> = (props) => {
  if (props.isShow) {
    return (<div className="download-confirmation">
      <Container>
        <div className="download-confirmation__background">
          <Header as="h2" className="download-confirmation__title">Hurray! <br />
            Your subscription was successful.
          </Header>
          <div className="download-confirmation__details">
            You will receive an email with your subscription details and instructions to download our beta app.
        </div>
          <ReactSVG className="download-confirmation__illustration" src="assets/images/illustration-download.svg" />
        </div>
      </Container>
    </div>)
  }
  return null;
}

export const SubscriptionConfirmation = connect(mapStateToProps)(Confirmation);


// WEBPACK FOOTER //
// ./src/components/presentational/views/Download/sections/Confirmation/index.tsx